var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdiachi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7467 5.63335C13.0467 2.55335 10.36 1.16669 8 1.16669C8 1.16669 8 1.16669 7.99334 1.16669C5.64 1.16669 2.94667 2.54669 2.24667 5.62669C1.46667 9.06669 3.57334 11.98 5.48 13.8134C6.18667 14.4934 7.09334 14.8334 8 14.8334C8.90667 14.8334 9.81334 14.4934 10.5133 13.8134C12.42 11.98 14.5267 9.07335 13.7467 5.63335ZM8 8.97335C6.84 8.97335 5.9 8.03335 5.9 6.87335C5.9 5.71335 6.84 4.77335 8 4.77335C9.16 4.77335 10.1 5.71335 10.1 6.87335C10.1 8.03335 9.16 8.97335 8 8.97335Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdiachi);
export default __webpack_public_path__ + "static/media/idiachi.40f048b29749d55a26e93d4eb9aa29f3.svg";
export { ForwardRef as ReactComponent };